<template>
<div class="h-100">

    <h2 class="step-title" v-text="__('trads.Set-your-payment-method')"></h2>
    <h3 class="subscription-start text-center" v-text="__('trads.Your-subscription-starts-immediately-after-you-set-up-your-payment')"></h3>

    <div class="payment-recap">
        <div class="plan-sub text-left">
            <div class="period" v-text="currentPlan.period"></div>
            <div class="billing-time" v-text="coupon ? currentPlan.promo : currentPlan.time"></div>

            <span
                class="money-saved"
                v-text="__('trads.percent-saved', {percent: 50})"
                v-if="currentPlan.highlighted"
                >
            </span>
        </div>
        <a class="change-plan" @click.prevent="previous" href="">{{ __('trads.Change') }}</a>
    </div>

    <hr class="my-3">

    <div class="secured-payment d-flex">
        {{ __('trads.Secured-payment') }}
        <img src="/img/style/secured-payment.svg">
    </div>

    <div class="checkout-container"></div>

</div>

</template>

<script>
export default {
    props: ['selected', 'email', 'coupon'],
    data () {
        return {
            currentPlan: {}
        }
    },
    beforeMount () {
        for (var n in this.$parent.plans) {
            var plan = this.$parent.plans[n];
            if (this.selected == plan.id) {
                this.currentPlan = plan;
                break;
            }
        }
    },
    mounted () {
        this.open();
    },
    methods: {
        previous () {
            this.$parent.previousStep();
        },
        open () {
            const that = this;

            if (window.paddleBilling) {
                // Paddle Billing (v2). Inline settings come from Paddle.Initialize() in register.blade.php.
                Paddle.Checkout.open({
                    items: [{ priceId: this.selected, quantity: 1 }],
                    customer: { email: this.email }
                });

                // The Initialize-level eventCallback (in register.blade.php) handles global coupon events,
                // but we need to also subscribe here to fire completedCheckout when this specific checkout succeeds.
                // Paddle.js v2 fires events via the global eventCallback registered in Initialize. To bridge it
                // back to this component, we listen on window for a custom event that the global callback re-emits.
                window.addEventListener('paddle:checkout-completed', function handler(e) {
                    that.$root.$emit('completedCheckout', JSON.stringify(e.detail));
                    window.removeEventListener('paddle:checkout-completed', handler);
                });
            } else {
                // Paddle Classic (legacy)
                Paddle.Checkout.open({
                    method: 'inline',
                    locale: window.locale,
                    product: this.selected,
                    email: this.email,
                    country: window.country,
                    postcode: "75000",
                    allowQuantity: false,
                    disableLogout: true,
                    frameTarget: 'checkout-container',
                    frameInitialHeight: 450,
                    frameStyle: 'width:100%; min-width:312px; background-color: transparent; border: none;',
                    successCallback: function(data) {
                        that.$root.$emit('completedCheckout', JSON.stringify(data));
                    },
                    closeCallback: function(data) {
                        console.log(data);
                        alert('Failed to checkout');
                    }
                });
            }
        }
    },
}
</script>

<style>
</style>
